export enum IdfDrawerDirection {
  RTL = 'rtl',
  LTR = 'ltr',
  BTT = 'btt',
  TTB = 'ttb',
}
